import {Inject, Injectable} from '@angular/core';
import {WINDOW} from '../../window.providers';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {DOCUMENT} from '@angular/common';
import {GlobalService} from '../../global.service';

@Injectable({
  providedIn: 'root'
})
export class HotlapsService {

  constructor(@Inject(WINDOW) private window: Window, private globalService: GlobalService, private httpClient: HttpClient, @Inject(DOCUMENT) private document: Document, private handler: HttpBackend) { }

  getHotlapTracks() {
    return this.httpClient.get( this.globalService.apiUrl + "/hotlaps/tracks");
  }
  getHotlapCars() {
    return this.httpClient.get( this.globalService.apiUrl + "/hotlaps/cars");
  }
  getHotlapVersions() {
    return this.httpClient.get( this.globalService.apiUrl + "/hotlaps/versions");
  }
  getHotlapMajorVersions() {
    return this.httpClient.get( this.globalService.apiUrl + "/hotlaps/majorversions");
  }
  getHotlapClasses() {
    return this.httpClient.get( this.globalService.apiUrl + "/hotlaps/classes");
  }

  getHotLaps(filter, source) {
    return this.httpClient.get( this.globalService.apiUrl + "/hotlaps?track=" + filter.track + '&class=' + filter.class + '&car=' + filter.car + '&major=' + filter.major + '&version=' + filter.version + '&source=' + source);
  }

  getHotLapsByCar(filter, source) {
    return this.httpClient.get( this.globalService.apiUrl + "/hotlaps/getFastestLapsPerCar?track=" + filter.track + '&class=' + filter.class + '&car=' + filter.car + '&major=' + filter.major + '&version=' + filter.version + '&source=' + source);
  }

  getBop(filter) {
    return this.httpClient.get( this.globalService.apiUrl + "/hotlaps/getBopPrediction?track=" + filter.track + '&class=' + filter.class + '&car=' + filter.car + '&major=' + filter.major + '&version=' + filter.version);
  }

  getAccBoP() {
    return this.httpClient.get( this.globalService.apiUrl + "/hotlaps/getAccBop");
  }

  getBopFileDownload(uid) {

    window.open(this.globalService.apiUrl + "/hotlaps/getAccBopDownload?k=" + btoa("daduserthingy" + uid));

  }


}
